<template>
  <div class="cata-content">
    <arrorImg bg="white"></arrorImg>
    <navBar title="目录" color="#ffffff"></navBar>
    <div class="cata-title">
      <span class="cata-title-text">共{{ total }}章</span>
      <div @click="selectCata" class="cata-text">
        <span class="cata-text-text">第{{ selectText }}章</span>
        <img
          class="cata-arrow"
          :class="isShowSelect ? 'cata-arrow-active' : ''"
          src="../../../static/arrow.png"
          alt=""
        />
        <div class="cata-select" v-if="isShowSelect">
          <span
            class="cata-select-text"
            v-for="(item, index) in selectList"
            @click="chooseCata(item, index)"
            :key="index"
            >第{{ item }}章</span
          >
        </div>
      </div>
    </div>
    <div class="content-box">
      <div
        class="content-box-view"
        :ref="'pageContainer'+index"
        v-for="(item, index) in cataList"
        :key="index"
        @click="routeRead(item)"
      >
        <span
          class="content-box-text"
          :class="chapterorder == item.chapterOrders ? 'chapter-cative' : ''"
          >第{{ item.chapterOrders }}章 {{ item.chapterName }}</span
        >
        <img
          v-if="item.txtIsCharge === 1"
          class="lock-image"
          src="../../../static/lock_icon.png"
          alt=""
        />
      </div>
    </div>
    <qCode
      :qcodeUrl="qcodeUrl"
      :isShowQcode="isShowQcode"
      @eventChange="eventChange"
    ></qCode>
    <buyBook
      :showBuyMask="showBuyMask"
      :countCurrency="countCurrency"
      @buyChange="buyChange"
      :userCurrency="userCurrency"
    ></buyBook>
       <autoBuy  :showAutoBuyMask="showAutoBuyMask"
      :countCurrency="countCurrency"
      @autobuyChange="autobuyChange"
      :userCurrency="userCurrency"></autoBuy>
  </div>
</template>
<script>
import {Toast, MessageBox } from "mint-ui";
import arrorImg from "../../components/arrow-img.vue";
import qCode from "../bookRead/component/qcode.vue";
import navBar from "../components/navbar.vue";
import buyBook from "../components/buyBook.vue";
import autoBuy from "../components/autoBuy.vue";
export default {
  components: {
    arrorImg,
    qCode,
    navBar,
    buyBook,
    autoBuy
  },
  data() {
    return {
        showAutoBuyMask:false,//显示是否订阅弹窗
      countCurrency: 0, //整本书币，
      showBuyMask: false, //显示整本订购弹窗
      userCurrency: 0, //用户剩余书币
      purchaseWholeBook: 0,
      total: 1,
      bookId: 0,
      chapterorder: 1,
      pageNo: 1,
      cataList: [],
      selectList: [],
      pageCount: 1,
      selectText: "",
      isShowSelect: false,
      isReload: false, //是否刷新
      qcodeUrl: "",
      isShowQcode: false,
      isEntranceData: "",
      item: {},
      showAutoBuyMask:false,
      isauto:0,
      pageType:'',
    };
  },
  mounted() {
    this.bookId = this.$route.query.bookId;
    this.pageType = this.$route.query.pageType;
    if (this.$route.query.isEntranceData) {
      this.isEntranceData = this.$route.query.isEntranceData;
    }
    var openid = this.$base.getStorage("openid");
    var isWxAuthorized = this.$base.getStorage("isWxAuthorized");
  var city = this.$base.getStorage("city");
    if (!openid) {
      //静默登录手动登录
    } else if (isWxAuthorized==0&&city==1 && openid && !this.$store.state.user.isSNS) {
      this.$base.setStorage("isSNS", true);
      this.$store.state.user.isSNS = true;
      this.$commonApi.snsapiUserinfo();
      this.getbookreadlog();
       this.getOrderStatus();
    } else {
      this.getbookreadlog();
       this.getOrderStatus();
    }
   
    this.$commonApi.share();//分享暂定
  },
  methods: {
    	  getOrderStatus() {
      if(this.$base.getStorage("orderNum")&&this.$base.getStorage('isActivity')){
        var params = {
          orderNo: this.$base.getStorage("orderNum"),
          currentPageType:1
        };
        this.$api.getOrderStatus(params).then((res) => {
          this.$base.removeStorage("orderNum");
          this.$base.removeStorage("isActivity");
          if (res.status == 1) {
            Toast({
              message: res.message
            });
          }
        });
      }
    },
    insertPageAccessData() {
      var prevPage = "";
      if (this.pageType === "bookCity") {
        prevPage = "书城";
      } else if (this.pageType === "bookRecharge") {
        prevPage = "充值中心";
      }else if (this.pageType === "bookDetail") {
        prevPage = "书籍详情";
      }
      var params = {
        pageName: "目录",
        pageRemark: '上级页面：'+prevPage+";书籍ID：" + this.bookId,
        isEntranceData: this.isEntranceData,
      };
      this.$api.insertPageAccessData(params).then((res) => {});
    },
    getbookreadlog() {
      var params = {
        bookId: this.bookId,
        chapterId: -1,
      };
      this.$api.getbookreadlog(params).then((res) => {
        if (res.status == 1) {
          if (res.data.chapterPos) {
            this.chapterorder = res.data.chapterPos;
          } else {
            this.chapterorder = 1;
          }
        } else {
          this.chapterorder = 1;
        }
        this.pageNo = Math.ceil(this.chapterorder / 100);
        this.getBookCatlogs();
        this.insertPageAccessData();
      });
    },
    getBookCatlogs() {
      var params = {
        order: 0,
        bookId: this.bookId,
        pageNo: this.pageNo,
        pageSize: 100,
      };
      this.$api.getBookCatlogs(params).then((res) => {
        if (res.status == 1) {
          this.total = res.counts;
          this.pageCount = res.pages;
          this.selectList = [];
          for (var j = 0; j < res.pages; j++) {
            if (j == res.pages - 1) {
              if (this.total == j * 100 + 1) {
                this.selectList.push(j * 100 + 1);
              } else {
                this.selectList.push(j * 100 + 1 + "-" + this.total);
              }
            } else {
              this.selectList.push(j * 100 + 1 + "-" + (j + 1) * 100);
            }
          }
          this.cataList = res.data;
          var scrollTop = 0;
          console.log(this.$refs.pageContainer1)
          this.cataList.forEach((item) => {
            if (item.chapterOrders == this.chapterorder) {
              if(this.chapterorder % 100==0){
									scrollTop = 100 * 47;
								}else{
									scrollTop = ((this.chapterorder % 100) - 1) * 47;
								}
								
            }
          });
          setTimeout(() => {
            window.scrollTo(0,scrollTop)
          }, 100);
          for (var i = 0; i < this.selectList.length; i++) {
            if (this.pageNo == i + 1) {
              this.selectText = this.selectList[i];
            }
          }
        }
      });
    },
    selectCata() {
      this.isShowSelect = !this.isShowSelect;
    },
    chooseCata(item, index) {
      this.selectText = item;
      this.pageNo = index + 1;
      this.getBookCatlogs();
    },
    eventChange() {
      this.isShowQcode = false;
    },
    buyChange(data) {
      if (data) {
        if (data == 1) {
          this.purchaseWholeBook = 1;
          this.routeRead(this.item);
        } else if (data == 2) {
          this.showBuyMask = false;
          this.$router.push({
            path: "/pages/bookCharge/index",
            query: {
              bookId: this.bookId,
              needCurrency: this.countCurrency,
              pageType: "bookRead",
            },
          });
        }
      } else {
        this.showBuyMask = false;
      }
    },
      autobuyChange(item) {
      //是否订阅
      if (item) {
        if (item.data == 1) {
          this.isauto = item.isauto;
          this.purchaseWholeBook=1;
           this.routeRead(this.item);
        } else if (item.data == 2) {
           this.showAutoBuyMask = false;
           this.isauto = item.isauto;
            this.$base.setStorage(
              "isauto",
              this.isauto
            );
          this.$router.push({
            path: "/pages/bookCharge/index",
            query: {
               bookId: this.bookId,
              needCurrency: this.countCurrency,
              pageType: "bookRead",
            },
          });
        }
        // else if(item.data == 3){
        //    this.isauto = item.isauto;
        // }
      } else {
        this.showAutoBuyMask = false;
      }
    },
    routeRead(item) {
      this.item = item;
      var params = {
        bookId: this.bookId,
        chapterId: item.id, //章节排序order
        chapterorder: item.chapterOrders, //翻页标示 0:获取当前章节内容 1: 前一章 2：后一章,4从目录进入阅读器,3购买章节
        order: 4,
        booktype: "",
        isauto: this.isauto,
        rechargeOrderNum: "", //订单编号
        purchaseWholeBook: this.purchaseWholeBook,
        currentPageType:1
      };
      if (this.$base.getStorage("orderNum")) {
        this.$base.setStorage("orderNum", "");
      }
      this.$api.findChapterContentByChapterId(params).then((res) => {
        if (res.status == 1) {
          this.showBuyMask = false;
          this.purchaseWholeBook = 0;
          if (res.data.qRCodeUrl != "") {
            //H5获取公众号二维码凭证
            this.isShowQcode = true;
            this.qcodeUrl = res.data.qRCodeUrl;
          } else {
            this.$router.push({
              path: "/pages/bookRead/index",
              query: {
                bookid: this.bookId,
                item: JSON.stringify(item),
                pageType: "bookCatalog",
              },
            });
          }
        } else if (res.status == 3) {
          this.showBuyMask = true;
          this.countCurrency = res.data.wholeBookCurrency;
          this.userCurrency = res.data.accountCurrency;
        } else if (res.status == 100 || res.status == 200) {
            if (res.data) {
              this.$router.push({
                path: "/pages/bookCharge/index",
                query: {
                  bookId: this.bookId,
                  chapterId: res.data.id,
                  needCurrency: res.data.chapterPrice,
                  pageType: "bookRead",
                  priceType:res.data.priceType
                },
              });
            }
        }else  if(res.status==4){//订阅流程
      
           this.countCurrency = res.data.chapterPrice;
          this.userCurrency = res.data.accountCurrency;
               this.showAutoBuyMask=true;
        }else{
           Toast({
            message: res.message,
          });
        }
      });
    },
  },
};
</script>
<style scoped>
.cata-content {
  overflow: hidden;
  /* height:calc(48px + env(safe-area-inset-bottom)); */
  padding-bottom: constant(safe-area-inset-bottom);
  /* 兼容 iOS < 11.2 */
  padding-bottom: env(safe-area-inset-bottom);
  /* 兼容 iOS >= 11.2 */
  /* box-sizing: content-box; */
}
.cata-title {
  padding: 9px 0px 9px 16px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #f3f3f3;
  position: fixed;
  width: 100%;
  background-color: #ffffff;
  box-sizing: border-box;
  z-index: 99;
  top: 44px;
  	   left: 0;
}
.cata-title > .cata-title-text {
  font-size: 14px;
  color: #888888;
}
.cata-text {
  font-size: 14px;
  color: #333333;
  width: 138px;
  position: relative;
}

.cata-arrow {
  position: absolute;
  right: 15px;
  top: 7px;
  width: 6.1px;
  height: 4.4px;
}

.cata-arrow-active {
  transform: rotate(180deg);
}

.cata-text-text {
  display: block;
  font-size: 14px;
  color: #333333;
  padding: 0px 9px 0px 12px;
}

.cata-select {
  position: absolute;
  right: 0px;
  top: 29px;
  background-color: #ffffff;
  width: 100%;
  overflow-y: scroll;
  height: calc(100vh - 90px);
}
.cata-select-text {
  display: block;
  padding: 18px 9px 4px 12px;
}

.content-box {
  background: #f3f3f3;
  padding: 0px 16px;
}

.content-box {
 padding-top: calc(72px + env(safe-area-inset-top));
}
.content-box-view {
  display: flex;
  justify-content: space-between;
  padding-top: 20px;
  padding-bottom: 8px;
}

.content-box-text {
  font-size: 14px;
  color: #666666;
  text-overflow: ellipsis;
  width: 270px;
  white-space: nowrap;
  overflow: hidden;
}

.lock-image {
  width: 18px;
  height: 21px;
}

.content-box .chapter-cative {
  color: #de3b34;
  font-weight: bold;
}



</style>



// WEBPACK FOOTER //
// src/view/bookCatalog/index.vue